import * as React from "react";

import { useFetchFeed } from "./useFetchFeed";

import type { BoardDocument } from "./useFetchFeed";

const POLL_INTERVAL = 5000; // 5 seconds

export const usePollDocumentsFeed = (
  feedId: string,
  callback?: CallbackType
) => {
  const [pollingEnabled, setPollingEnabled] = React.useState(false);

  const refetchInterval = React.useMemo(() => {
    if (!pollingEnabled) return false;
    return POLL_INTERVAL;
  }, [pollingEnabled]);

  const enabled = React.useMemo(() => {
    if (!feedId) return false;
    return pollingEnabled;
  }, [feedId, pollingEnabled]);

  const {
    data: feedData,
    isFetching,
    refetch,
  } = useFetchFeed(feedId, refetchInterval, enabled);

  const startPolling = React.useCallback(() => {
    if (pollingEnabled) return;
    setPollingEnabled(true);
    refetch();
  }, [pollingEnabled, refetch]);

  const stopPolling = React.useCallback(() => {
    setPollingEnabled(false);
  }, []);

  React.useEffect(() => {
    if (feedData && feedData.documents) {
      callback?.(feedData.documents);
    }
  }, [feedData, callback]);

  return { feedData, isFetching, startPolling, stopPolling, pollingEnabled };
};

type CallbackType = (documents: BoardDocument[]) => void;
